<div *ngIf="!show3DPreviewer" class="volumental-wrapper">
    <volumental-measurement-embedded id="volumental-widget" [attr.subject]="userId" locale="es">
    </volumental-measurement-embedded>
</div>

<p-dialog header="3D Previewer" [(visible)]="show3DPreviewer" [modal]="true" (onHide)="goToHome()"
    (onShow)="on3DModalShown()" [style]="{ width: '100vw', height: '100vh', margin: '0', padding: '0' }"
    [maximizable]="false">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <div *ngIf="token && token !== null && token !== ''" style="width: 100%; height: 100%; margin: 0; padding: 0;">
        <iframe id="3D_previewer" class="previewer-iframe"
            sandbox="allow-scripts allow-same-origin allow-storage-access-by-user-activation"
            [src]="iframeUrl"></iframe>
        <div class="button-container">
            <button mat-raised-button color="primary" class="btn btn-block icon-button" (click)="goToHome()">
                Finish
            </button>
        </div>
    </div>
</p-dialog>